import { WidgetWrapper } from '@agentselly/ui';
import { EmptyState } from '~/components/empty/EmptyState';
import { AppLink } from '~/components/AppLink';
import { T, useTranslate } from '@tolgee/react';
import { Button } from '~/components/ui/Button';

interface Props {
  readonly title?: string;
  readonly description?: string;
  readonly iframeUrl?: string;
  readonly link?: string;
  readonly fallback?: {
    readonly keyPrefix: string;
    readonly title: string;
    readonly description: string;
  };
}

const NEUTRAL_FALLBACK = {
  keyPrefix: 'iframe_unavailable',
  title: 'Inhalt nicht verfügbar',
  description: 'Dieser Inhalt liegt aktuell nicht vor.',
};

const MAP_FALLBACK = {
  keyPrefix: 'map_unavailable',
  title: 'Karte nicht verfügbar',
  description: 'Für diese Lage liegt aktuell keine Karte vor.',
};

export function IframeWidget(props: Props) {
  const { t } = useTranslate();

  if (!props.iframeUrl) {
    const fb = props.fallback ?? NEUTRAL_FALLBACK;
    return (
      <WidgetWrapper>
        <EmptyState
          title={t(`${fb.keyPrefix}_title`, fb.title)}
          description={t(`${fb.keyPrefix}_description`, fb.description)}
        />
      </WidgetWrapper>
    );
  }

  return (
    <WidgetWrapper>
      <div className="flex flex-col gap-y-6 overflow-hidden">
        {props.title && (
          <h2 className="text-lg font-bold">
            <T keyName={props.title} />
          </h2>
        )}
        {props.description && (
          <p>
            <T keyName={props.description} />
          </p>
        )}
        <div className="aspect-w-4 aspect-h-3">
          <iframe
            title="IDiframe"
            tabIndex={-1}
            src={props.iframeUrl}
            className="w-full h-full rounded-lg"
          />
        </div>

        {props.link ? (
          <AppLink
            to={props.link}
            className="self-start pt-4"
          >
            <Button showArrow>
              <T>widget_evaluation_button_text</T>
            </Button>
          </AppLink>
        ) : null}
      </div>
    </WidgetWrapper>
  );
}

export function MapIframeWidget(props: Props) {
  return (
    <IframeWidget
      fallback={MAP_FALLBACK}
      {...props}
    />
  );
}
